module.exports = __webpack_public_path__ + "static/media/sucess.3ef699d3.svg";